import {IonButton, IonCheckbox, IonLabel} from "@ionic/react";
import {useForm} from "react-hook-form";
import {useState} from "react";

import {Input, FileUpload} from "../../../components";

import "../Details/detail.style.css";
import {useQuery, useMutation} from "@apollo/client";
import {GET_MY_DETAIL} from "../../../graphql/queries/common.query";
import {REQUEST_ESTIMATE} from "../../../graphql/mutations/quote.mutation";
import toast from "react-hot-toast";
import {ErrorMessage} from "@hookform/error-message";
import {GET_PRIVACY_POLICY} from "../../../graphql/queries/policy.query";
import {isAuthenticated} from "../../../lib/utils/auth.utils";

interface CustomQuoteProps {
  onComplete: any;
}

export default function CustomQuote(props: CustomQuoteProps) {
  const [privacyPolicy, setPrivacyPolicy] = useState<
    | {
        id: number;
        title: string;
        body: string;
        footer: string;
        type: string;
        placeholders: [];
      }
    | any
  >();
  const {
    handleSubmit,
    register,
    setValue,
    formState: {errors},
  } = useForm({
    defaultValues: {
      email: null,
      firstName: null,
      lastName: null,
      description: null,
      documents: null,
    },
  });

  if (isAuthenticated()) {
    useQuery(GET_MY_DETAIL, {
      fetchPolicy: "cache-and-network",
      notifyOnNetworkStatusChange: true,
      onCompleted(data) {
        const result = data?.getMyDetail.customer;
        if (result) {
          setValue("firstName", result.firstName);
          setValue("lastName", result.lastName);
          setValue("email", result.email);
        }
      },
    });
  }

  useQuery(GET_PRIVACY_POLICY, {
    variables: {type: "quote"},
    onCompleted(data) {
      const actualData = data.getPrivacyPolicy.data;
      if (actualData) setPrivacyPolicy(actualData);
    },
  });

  const [requestEstimateMutation] = useMutation(REQUEST_ESTIMATE, {
    onCompleted(data) {
      if (data.requestEstimate.errors?.length) {
        toast.error(data.requestEstimate.errors[0].message);
      } else {
        toast.success("Richiesta inviata correttamente!");
        props.onComplete();
      }
    },
  });

  const [accepted, setAccepted] = useState(false);

  const formSubmit = (data: any) => {
    requestEstimateMutation({
      variables: {
        description: data.description,
        documents: data.documents ?? null,
        telephone: data.telephone ?? null,
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        acceptedTerms: accepted,
        token: "random",
      },
    });
  };

  return (
    <div className="custom-quote-form">
      <h4 className="text-center">
        <strong>Compila i dati per richiedere informazioni</strong>
      </h4>
      <Input
        name="Nome"
        registerName="firstName"
        register={register}
        errors={errors}
        requiredMessage="Nome e obbligatario"
      />
      <Input
        name="Cognome"
        registerName="lastName"
        register={register}
        errors={errors}
        requiredMessage="Cognome e obbligatario"
      />
      <Input
        name="Indirizzo email"
        registerName="email"
        register={register}
        errors={errors}
        requiredMessage="Indirizzo email e obbligatario"
        pattern={{
          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
          message: "Indirizzo email non valido",
        }}
      />
      <Input
        name="Numero cellullare"
        registerName="telephone"
        register={register}
        errors={errors}
      />

      <div>
        <IonLabel className="app-input-label">Richiesta</IonLabel>
        <textarea
          {...register("description", {
            required: "Richesta e obbligatario",
          })}
          className="app-input-field custom-quote-textarea"
        />
        <span className="error-msg">
          <ErrorMessage errors={errors} name="description" as={"span"} />
        </span>
      </div>

      <div style={{marginTop: "0.5rem"}}>
        <FileUpload
          form={{
            registerName: "documents",
            register,
            errors,
            setValue,
          }}
          fieldName="Carica documenti"
          dragAndDrop
        />
      </div>

      <div className="custom-quote-flex">
        <div className="custom-quote-checkbox">
          <IonCheckbox
            color="primary"
            slot="start"
            checked={accepted}
            onIonChange={(e) => {
              setAccepted(e.detail.checked);
            }}
          />
        </div>
        <p>
          {privacyPolicy && privacyPolicy.footer && (
            <small
              dangerouslySetInnerHTML={{
                __html: privacyPolicy?.footer?.replace(
                  /{{url}}/gi,
                  `${window.location.origin}/privacy-policy/quote`
                ),
              }}
            ></small>
          )}
        </p>
      </div>
      <IonButton
        color="success"
        shape="round"
        expand="full"
        disabled={!accepted}
        onClick={handleSubmit(formSubmit)}
      >
        Invia
      </IonButton>
    </div>
  );
}
